<template>
  <hr
    class="pixel-divider"
    :style="{
      height: height,
      'margin-top': marginTop,
      'margin-bottom': marginBottom,
      margin: noMargin ? '0px' : false,
      'background-color': color,
    }"
  />
</template>

<script>
export default {
  name: 'Divider',
  props: {
    noMargin: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: [String, Boolean],
      default: 'var(--space-6)',
    },
    marginBottom: {
      type: [String, Boolean],
      default: 'var(--space-6)',
    },
    height: {
      type: String,
      default: '4px',
    },
    color: {
      type: String,
      default: 'var(--background-color)',
    },
  },
};
</script>

<style lang="postcss">
hr.pixel-divider {
  border: 0px;
}
</style>
